const Asia = [
  {
    id: 11,
    continent: 'asia',
    img: require("../Images/Asia/Shanghai-alexandre-valdivia.jpg"),
    title: "Shanghai",
    quote:
      "There is something in Shanghai that is very exciting and alive - the idea of a city with two different souls, one from today and another from a long time ago, is amazing.",
    autor: "Alessandro Michele",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "23/02/2036",
    dailyTripDate2: "23/08/2036",
    dailyTripDate3: "23/10/2036",
    dailyPriceAdult: 139.99,
    dailyPriceChildren: 39.99,
    weekTrip: true,
    weekTripDate1: "24/02/2036 - 31/03/2036",

    weekTripDate2: "24/08/2036 - 31/08/2036",

    weekTripDate3: "24/10/2036 - 31/10/2036",

    weekPriceAdult: 699.99,
    weekPriceChildren: 399.99,
    monthTrip: false,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/asia/shanghai",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 59,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 49,
    hotelOption2: 69,
    choosenHotel: 0,
    tripStandard: "Unavaiable",
    tripOption1: 79,
    tripDescription1:
      "Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.",
    tripOption2: 129,
    tripDescription2:
      "Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae",
    tripOption3: 149,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 12,
    continent: 'asia',
    img: require("../Images/Asia/Kuala-lumpur-azlan-baharudin.jpg"),
    title: "Kuala Lumpur",
    quote:
      "A skyline punctuated by minarets, Mogul-style domes and skyscrapers; colourful, food-stall-lined streets shaded by a leafy canopy of banyan trees – this is Kuala Lumpur.",
    autor: null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "08/03/2036",
    dailyTripDate2: "08/05/2036",
    dailyTripDate3: "08/08/2036",
    dailyPriceAdult: 299.99,
    dailyPriceChildren: 199.99,
    weekTrip: true,
    weekTripDate1: "10/03/2036 - 17/03/2036",

    weekTripDate2: "10/05/2036 - 17/05/2036",

    weekTripDate3: "10/08/2036 - 17/08/2036",

    weekPriceAdult: 699.99,
    weekPriceChildren: 399.99,
    monthTrip: false,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/asia/kuala-lumpur",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 29,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 69,
    hotelOption2: 99,
    hotelOption3: 139,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 45,
    tripDescription1:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit.",
    tripOption2: 99,
    tripDescription2:
      "Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus.",
    // tripOption3: 149,
    // tripDescription3: 'Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.',
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 13,
    continent: 'asia',
    img: require("../Images/Asia/Tokio-jezael-melgoza.jpg"),
    title: "Tokio",
    quote:
      "One of my favorite cities is Tokyo because of sushi, and Asian food in general, but then also the way Tokyo operates, because it's so clean, and there's space for a lot of variety of stores.",
    autor: "Lauv",
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "19/02/2036",
    dailyTripDate2: "19/08/2036",
    dailyTripDate3: "19/10/2036",
    dailyPriceAdult: 149.99,
    dailyPriceChildren: 49.99,
    weekTrip: true,
    weekTripDate1: "19/02/2036 - 26/02/2036",

    weekTripDate2: "19/08/2036 - 26/08/2036",

    weekTripDate3: "19/10/2036 - 26/10/2036",

    weekPriceAdult: 699.99,
    weekPriceChildren: 499.99,
    monthTrip: false,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/asia/tokio",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: "Unavaiable",
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 69,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 29,
    tripDescription1:
      '"In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit.',
    tripOption2: 59,
    tripDescription2:
      '"Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor.',
    tripOption3: 89,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 14,
    continent: 'asia',
    img: require("../Images/Asia/Sigapore-kelvin-zyteng.jpg"),
    title: "Singapore",
    quote:
      "Capitalising on its melting pot of cultures, Singapore is finally getting some spark, and is fast becoming one of Asia’s hit-list destinations.",
    autor: null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "29/02/2036",
    dailyTripDate2: "29/08/2036",
    dailyTripDate3: "29/10/2036",
    dailyPriceAdult: 129.99,
    dailyPriceChildren: 49.99,
    weekTrip: false,
    weekTripDate1: "03/02/2036 - 10/02/2036",

    weekTripDate2: "03/08/2036 - 10/08/2036",

    weekTripDate3: "03/10/2036 - 10/10/2036",

    weekPriceAdult: 499.99,
    weekPriceChildren: 299.99,
    monthTrip: true,
    monthTripDate1: "30/03/2036 - 30/04/2036",
    monthTripDate2: "30/06/2036 - 30/07/2036",
    monthTripDate3: "30/09/2036 - 30/10/2036",
    monthPriceAdult: 1299.99,
    monthPriceChildren: 999.99,
    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/asia/sigapore",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 109,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    hotelOption2: 89,
    choosenHotel: 0,
    tripStandard: "Unavaiable",
    tripOption1: 29,
    tripDescription1:
      "Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.",
    tripOption2: 49,
    tripDescription2:
      "Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae",
    tripOption3: 89,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 15,
    continent: 'asia',
    img: require("../Images/Asia/Bali-dennis-rochel.jpg"),
    title: "Bali",
    quote:
      "The Island of the Gods offers great beaches, countless waves for surfing and wonderful natural sites to visit and explore, colorful ceremonies, and gifted artists.",
    autor: null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: true,
    dailyTripDate1: "13/02/2036",
    dailyTripDate2: "13/08/2036",
    dailyTripDate3: "13/10/2036",
    dailyPriceAdult: 139.99,
    dailyPriceChildren: 39.99,
    weekTrip: true,
    weekTripDate1: "14/04/2036 - 20/04/2036",

    weekTripDate2: "14/05/2036 - 20/05/2036",

    weekTripDate3: "14/12/2036 - 20/12/2036",

    weekPriceAdult: 299.99,
    weekPriceChildren: 199.99,
    monthTrip: true,
    monthTripDate1: "27/03/2036 - 27/04/2036",
    monthTripDate2: "27/06/2036 - 27/07/2036",
    monthTripDate3: "27/09/2036 - 27/10/2036",
    monthPriceAdult: 1299.99,
    monthPriceChildren: 999.99,

    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/asia/bali",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: "Unavaiable",
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    hotelOption2: 59,
    hotelOption3: 89,
    choosenHotel: 0,
    tripStandard: "Unavaiable",
    tripOption1: 79,
    tripDescription1:
      "Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.",
    tripOption2: 129,
    tripDescription2:
      "Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae",
    tripOption3: 149,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  },
  {
    id: 16,
    continent: 'asia',
    img: require("../Images/Asia/Bangkok-florian-wehde.jpg"),
    title: "Bangkok",
    quote:
      "Marvel at the gleaming temples, catch a tuk tuk along the bustling Chinatown, eat the best street food or take a longtail boat through floating markets.",
    autor: null,
    adultCount: 0,
    childrenCount: 0,
    totalTravelers: 0,
    total: 0,
    dailyTrip: false,
    dailyTripDate1: "10/02/2036",
    dailyTripDate2: "10/08/2036",
    dailyTripDate3: "10/10/2036",
    dailyPriceAdult: 99.99,
    dailyPriceChildren: 49.99,
    weekTrip: true,
    weekTripDate1: "18/01/2036 - 25/01/2036",
    weekTripDate2: "18/05/2036 - 25/05/2036",
    weekTripDate3: "18/11/2036 - 25/11/2036",
    weekPriceAdult: 399.99,
    weekPriceChildren: 299.99,
    monthTrip: true,
    monthTripDate1: "12/03/2036 - 12/04/2036",
    monthTripDate2: "12/06/2036 - 12/07/2036",
    monthTripDate3: "12/09/2036 - 12/10/2036",
    monthPriceAdult: 999.99,
    monthPriceChildren: 499.99,

    choosenTrip: "",
    tripPriceAdult: "",
    tripPriceChildren: "",
    dateOption: "",
    choosenDate: "",
    link: "/asia/bangkok",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue luctus vestibulum. Proin posuere magna nec leo tincidunt, eget interdum enim consectetur. Maecenas vehicula mattis nunc sed pharetra. Donec auctor, ex sit amet egestas sollicitudin, ipsum tortor porttitor odio, eu commodo odio diam laoreet ex. Vestibulum suscipit nisi non convallis molestie. Etiam et sapien felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer elit massa, vestibulum quis faucibus vel, euismod sed quam. Mauris ultricies, urna sit amet bibendum sollicitudin, nisi mi faucibus nibh, ac auctor tortor lacus in ex. Donec sed massa sodales, gravida urna eget, vestibulum elit.",
    description2:
      "Fusce placerat, felis vel semper sagittis, velit justo accumsan turpis, suscipit vestibulum purus ligula sit amet massa. Suspendisse sollicitudin porttitor porttitor. Vestibulum lacus elit, molestie sed neque ut, eleifend maximus mi. Suspendisse eget massa ac neque pulvinar varius eget vitae lectus. Duis non consectetur ex, sed scelerisque neque. Cras nec nibh rutrum, ultrices dui ut, faucibus orci. Maecenas venenatis urna vitae sapien convallis, in dignissim odio interdum. Pellentesque mi nisi, vehicula eu nibh sed, posuere vestibulum felis.",
    description3:
      "In feugiat risus id risus vulputate, eu pellentesque ipsum laoreet. Integer augue massa, condimentum laoreet vulputate vel, laoreet et elit. Ut rutrum ex velit. Mauris eu mauris egestas urna rhoncus viverra cursus eu eros. Donec sit amet sem lobortis, ornare tellus at, pharetra erat. Donec a dignissim nulla, aliquam semper nulla. Nam euismod porttitor elit, interdum hendrerit velit tempor eget.",
    inCart: false,
    standardPickUp: 0,
    pickUp: 129,
    choosenPickUp: 0,
    hotelStandard: 0,
    hotelOption1: 39,
    choosenHotel: 0,
    tripStandard: 0,
    tripOption1: 39,
    tripDescription1:
      "Donec sit amet dui tempus tellus congue scelerisque et id est. In consequat finibus consectetur.",
    tripOption2: 69,
    tripDescription2:
      "Quisque consectetur urna ut enim rhoncus, fringilla viverra augue dapibus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae",
    tripOption3: 99,
    tripDescription3:
      "Fusce sollicitudin vehicula pharetra. Etiam tincidunt quis magna id laoreet. Morbi ut placerat quam. Phasellus vel fermentum sapien.",
    choosenTripOption: 0,
    totalWithOptions: 0
  }
];

export default Asia;
